var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main grey darken-4"
  }, [_c('full-page', {
    ref: "fullpage",
    attrs: {
      "options": _vm.fullpageOptions,
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "main-visual"
  }, [_c('swiper', {
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_c('swiper-slide', {
    staticClass: "d-flex align-center"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xs font-weight-semibold font-secondary primary--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Farming Tomorrow")])]), _c('div', {
    staticClass: "tit-wrap overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xxl font-weight-regular",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('b', [_vm._v("이레아이에스")]), _vm._v("는 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("스마트팜의 근본인 농업을 연구합니다.")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed",
    attrs: {
      "large": "",
      "color": "white",
      "to": "/about#about"
    }
  }, [_vm._v("더 알아보기")])], 1)]), _c('div', {
    staticClass: "swiper-slide__bg",
    staticStyle: {
      "background-image": "url(/images/main/v1.jpg)"
    }
  })], 1), _c('swiper-slide', {
    staticClass: "d-flex align-center"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xs font-weight-semibold font-secondary primary--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Farming Tomorrow")])]), _c('div', {
    staticClass: "tit-wrap overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xxl font-weight-regular",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('b', [_vm._v("미래농업")]), _vm._v("의 "), _c('b', [_vm._v("비전")]), _vm._v("을 제시하고 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("농업 기술의 발전을 선도하는 기업이 되겠습니다.")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed",
    attrs: {
      "large": "",
      "color": "white",
      "to": "/solution/smartfarm/rmfarm#rmfarm"
    }
  }, [_vm._v("더 알아보기")])], 1)]), _c('div', {
    staticClass: "swiper-slide__bg",
    staticStyle: {
      "background-image": "url(/images/main/v2.jpg)"
    }
  })], 1), _c('swiper-slide', {
    staticClass: "d-flex align-center"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xs font-weight-semibold font-secondary primary--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Farming Tomorrow")])]), _c('div', {
    staticClass: "tit-wrap overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xxl font-weight-regular",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('b', [_vm._v("농업")]), _vm._v("과 "), _c('b', [_vm._v("IT기술")]), _vm._v("의 컨버전스로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("미래의 먹거리 혁신을 주도합니다.")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed",
    attrs: {
      "large": "",
      "color": "white",
      "to": "/technology#technology"
    }
  }, [_vm._v("더 알아보기")])], 1)]), _c('div', {
    staticClass: "swiper-slide__bg",
    staticStyle: {
      "background-image": "url(/images/main/v3.jpg)"
    }
  })], 1), _c('swiper-slide', {
    staticClass: "d-flex align-center"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xs font-weight-semibold font-secondary primary--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Farming Tomorrow")])]), _c('div', {
    staticClass: "tit-wrap overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xxl font-weight-regular",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('b', [_vm._v("재배")]), _vm._v("부터 "), _c('b', [_vm._v("유통")]), _vm._v("까지 여러분의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("안전하고 건강한 식탁을 책임집니다.")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed",
    attrs: {
      "large": "",
      "color": "white",
      "to": "/business#business"
    }
  }, [_vm._v("더 알아보기")])], 1)]), _c('div', {
    staticClass: "swiper-slide__bg",
    staticStyle: {
      "background-image": "url(/images/main/v4.jpg)"
    }
  })], 1), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })])], 1)], 1)]), _c('div', {
    staticClass: "section section--business grey darken-4"
  }, [_c('section', {
    staticClass: "main-section"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xs font-weight-semibold font-secondary primary--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Business")])]), _c('div', {
    staticClass: "overflow-hidden mb-8px"
  }, [_c('h3', {
    staticClass: "tit tit--xxl",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v("비즈니스")])]), _c('div', {
    staticClass: "tit-wrap overflow-hidden"
  }, [_c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-15",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v("Farm to Table! "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("농장설치, 재배 관리, 신선유통까지 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("스마트팜 통합 솔루션을 제공합니다.")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed",
    attrs: {
      "large": "",
      "color": "white",
      "to": "/business#business"
    }
  }, [_vm._v("더 알아보기")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "mt-20px mt-md-0px"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "data-aos": "fade-left",
      "data-aos-delay": "100",
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "rounded-tl",
    attrs: {
      "img": "/images/main/business-img.jpg"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": _vm.$vuetify.breakpoint.mdAndUp ? 334 / 286 : ''
    }
  }, [_c('div', {
    staticClass: "pa-32px"
  }, [_c('div', {
    staticClass: "tit tit--xs white--text"
  }, [_vm._v("솔루션")])])])], 1)], 1), _c('v-col', {
    attrs: {
      "data-aos": "fade-left",
      "data-aos-delay": "200",
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "img": "/images/main/business-img2.jpg"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": _vm.$vuetify.breakpoint.mdAndUp ? 334 / 286 : ''
    }
  }, [_c('div', {
    staticClass: "pa-32px"
  }, [_c('div', {
    staticClass: "tit tit--xs white--text"
  }, [_vm._v("시설")])])])], 1)], 1), _c('v-col', {
    attrs: {
      "data-aos": "fade-left",
      "data-aos-delay": "300",
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "img": "/images/main/business-img3.jpg"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": _vm.$vuetify.breakpoint.mdAndUp ? 334 / 286 : ''
    }
  }, [_c('div', {
    staticClass: "pa-32px"
  }, [_c('div', {
    staticClass: "tit tit--xs white--text"
  }, [_vm._v("재배")])])])], 1)], 1), _c('v-col', {
    attrs: {
      "data-aos": "fade-left",
      "data-aos-delay": "400",
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "rounded-br",
    attrs: {
      "img": "/images/main/business-img4.jpg"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": _vm.$vuetify.breakpoint.mdAndUp ? 334 / 286 : ''
    }
  }, [_c('div', {
    staticClass: "pa-32px"
  }, [_c('div', {
    staticClass: "tit tit--xs white--text"
  }, [_vm._v("서비스")])])])], 1)], 1)], 1)], 1)])], 1)], 1)], 1)]), _c('div', {
    staticClass: "section",
    staticStyle: {
      "background-image": "url(/images/main/technology-bg.jpg)"
    }
  }, [_c('section', {
    staticClass: "main-section text-center"
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-30px mb-md-40px",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "aspect-ratio": 1 / 1,
      "max-width": "120",
      "src": "/images/icon/icon-expand.png"
    }
  })], 1), _c('div', {
    staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xs font-weight-semibold font-secondary primary--text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v("Core technology")])]), _c('div', {
    staticClass: "overflow-hidden mb-8px"
  }, [_c('h3', {
    staticClass: "tit tit--xxl",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v("핵심기술 = 근권부 + 빅데이터")])]), _c('div', {
    staticClass: "tit-wrap overflow-hidden"
  }, [_c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-15",
    attrs: {
      "data-aos": "fade-down",
      "data-aos-delay": "200"
    }
  }, [_vm._v("농업의 핵심은 작물의 뿌리입니다. "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("국내 최고 수준의 근권부 측정 기술을 보유하고 있습니다.")])]), _c('div', {
    attrs: {
      "data-aos": "zoom-in",
      "data-aos-delay": "300"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed mx-auto",
    attrs: {
      "large": "",
      "color": "white",
      "to": "/technology#technology"
    }
  }, [_vm._v("더 알아보기")])], 1)])], 1)]), _c('div', {
    staticClass: "section",
    staticStyle: {
      "background-image": "url(/images/main/bigdata-bg.jpg)"
    }
  }, [_c('section', {
    staticClass: "main-section text-center"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xs font-weight-semibold font-secondary primary--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Big data")])]), _c('div', {
    staticClass: "tit-wrap tit-wrap--lg overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xxl",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v("빅데이터")])]), _c('div', {
    staticClass: "py-20px py-md-40px",
    staticStyle: {
      "border-top": "1px solid rgba(255,255,255,0.2)",
      "border-bottom": "1px solid rgba(255,255,255,0.2)"
    }
  }, [_c('v-row', {
    staticClass: "row-cols-md-5 text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "tit tit--xl font-secondary mb-10px mb-md-16px"
  }, [_c('ICountUp', {
    ref: "countUp",
    staticClass: "countup",
    attrs: {
      "delay": _vm.delay,
      "endVal": _vm.main.domesitc,
      "options": _vm.countUpOptions
    }
  }), _vm._v("+")], 1), _c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-13",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v("(주)이레아이에스 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("국내 사용지역")])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "tit tit--xl font-secondary mb-10px mb-md-16px"
  }, [_c('ICountUp', {
    ref: "countUp2",
    staticClass: "countup",
    attrs: {
      "delay": _vm.delay,
      "endVal": _vm.main.overseas,
      "options": _vm.countUpOptions
    }
  }), _vm._v("+")], 1), _c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-13",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v("(주)이레아이에스 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("해외 사용지역")])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "tit tit--xl font-secondary mb-10px mb-md-16px"
  }, [_c('ICountUp', {
    ref: "countUp3",
    staticClass: "countup",
    attrs: {
      "delay": _vm.delay,
      "endVal": _vm.main.farmhouse,
      "options": _vm.countUpOptions
    }
  }), _vm._v("+")], 1), _c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-13",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v("사용 농가")])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "tit tit--xl font-secondary mb-10px mb-md-16px"
  }, [_c('ICountUp', {
    ref: "countUp4",
    staticClass: "countup",
    attrs: {
      "delay": _vm.delay,
      "endVal": _vm.main.data,
      "options": _vm.countUpOptions
    }
  })], 1), _c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-13",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v("농가 데이터 센서 수")])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "tit tit--xl font-secondary mb-10px mb-md-16px"
  }, [_c('ICountUp', {
    ref: "countUp5",
    staticClass: "countup",
    attrs: {
      "delay": _vm.delay,
      "endVal": _vm.main.dataCollection,
      "options": _vm.countUpOptions2
    }
  }), _vm._v("억")], 1), _c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-13",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v("1일 데이터 수집량")])])], 1)], 1)])], 1)]), _c('div', {
    staticClass: "section grey darken-4"
  }, [_c('section', {
    staticClass: "main-section"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "order-md": "2"
    }
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "588",
      "aspect-ratio": 588 / 280,
      "src": "/images/main/product-img.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "order-md": "1"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
  }, [_c('h3', {
    staticClass: "tit tit--xs font-weight-semibold font-secondary primary--text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Product Descriptions")])]), _c('div', {
    staticClass: "overflow-hidden mb-8px"
  }, [_c('h3', {
    staticClass: "tit tit--xxl",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v("제품소개")])]), _c('div', {
    staticClass: "tit-wrap overflow-hidden"
  }, [_c('div', {
    staticClass: "tit tit--sm font-weight-regular line-height-15",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._v("농업의 미래를 선도하는 기업, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("혁신적인 기술과 전문성으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("친환경적인 스마트팜 혁신을 선도하고 있습니다.")])]), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed",
    attrs: {
      "large": "",
      "color": "white",
      "to": "/solution/smartfarm/rmfarm#rmfarm"
    }
  }, [_vm._v("더 알아보기")])], 1)])], 1)], 1)], 1)]), _c('div', {
    staticClass: "section fp-auto-height",
    staticStyle: {
      "background-image": "url(/images/main/contactus-bg.jpg)"
    }
  }, [_c('section', {
    staticClass: "py-40px py-md-60px py-lg-80px text-center"
  }, [_c('v-container', [_c('div', {
    attrs: {
      "data-aos": "zoom-in"
    }
  }, [_c('v-btn', {
    staticClass: "v-size--xx-large font-secondary rounded-0",
    attrs: {
      "outlined": "",
      "color": "white",
      "to": "/community/inquire"
    }
  }, [_vm._v("Contact us")])], 1), _c('div', {
    staticClass: "mw-1000px mt-30px mt-md-40px mx-auto",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    staticClass: "text-center",
    attrs: {
      "align": "center",
      "justify": "center",
      "justify-md": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "tit tit--xs font-weight-regular font-secondary primary--text",
    attrs: {
      "to": "/community/inquire"
    }
  }, [_vm._v("Smart Farm")])], 1), _c('v-col', {
    staticClass: "align-self-stretch d-none d-md-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "h-100",
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "tit tit--xs font-weight-regular font-secondary primary--text",
    attrs: {
      "to": "/community/inquire"
    }
  }, [_vm._v("Turnkey Greenhouses")])], 1), _c('v-col', {
    staticClass: "align-self-stretch d-none d-md-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "h-100",
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "tit tit--xs font-weight-regular font-secondary primary--text",
    attrs: {
      "to": "/community/inquire"
    }
  }, [_vm._v("Fresh Food")])], 1), _c('v-col', {
    staticClass: "align-self-stretch d-none d-md-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "h-100",
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "tit tit--xs font-weight-regular font-secondary primary--text",
    attrs: {
      "to": "/community/inquire"
    }
  }, [_vm._v("General")])], 1)], 1)], 1)])], 1)]), _c('div', {
    staticClass: "section section--footer fp-auto-height d-none d-xl-table"
  }, [_c('main-footer')], 1)]), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }